import React from "react";
import { Heading, VStack, Box } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { LOMA_LANDING_DARK_TEAL } from "../constants/colors";

const MotionVStack = motion(VStack);
const MotionBox = motion(Box);

export const HeroSection: React.FC = () => {
  return (
    <MotionVStack
      spacing={{ base: 4, md: 8 }}
      align="stretch"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      mb={{ base: 8, md: 12 }}
    >
      <MotionBox
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        textAlign="center"
        px={6}
      >
        <Heading
          as="h1"
          fontSize={{ base: "4xl", sm: "7xl" }}
          color="white"
          mb={{ base: 4, md: 6 }}
          lineHeight="1"
          fontWeight="300"
          style={{
            letterSpacing: "0.02em",
          }}
        >
          Custom Commerce Built for Your Audience
        </Heading>
      </MotionBox>
    </MotionVStack>
  );
};
